import * as React from "react";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody/TableBody";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import PercentageNumber from "../../../components/UI/PercentageNumber";
import Page from "./Page";

const ModelConstDisclosureManager = (props) => {
  const { manager, model, portfolio, userIsApproved } = props;
  const constituent = model.constituent;
  if (!constituent || !manager) {
    return null;
  }

  const managerName = manager.managerDetail.Name;
  const managerType = manager.managerDetail.GlobalCategory;
  const tickers = Object.keys(constituent).sort((a, b) =>
    a.toLowerCase().indexOf("index") > -1 ? -1 : 1
  );

  const COLUMNS_PER_PAGE = 5;
  const ROWS_PER_PAGE = 16;
  const RECORDS_PER_PAGE = ROWS_PER_PAGE * COLUMNS_PER_PAGE;
  const TOTAL_PAGES = Math.ceil(
    constituent[tickers[0]].length / RECORDS_PER_PAGE
  );

  return (
    <React.Fragment>
      {Array(TOTAL_PAGES)
        .fill("")
        .map((p, pageIndex) => {
          const recordIndexOnPageStarts = pageIndex * RECORDS_PER_PAGE;
          // const recordIndexOnPageEnds = (pageIndex + 1) * RECORDS_PER_PAGE;
          // console.log(`page ${pageIndex}: ${recordIndexOnPageStarts} to ${recordIndexOnPageEnds}`);

          return (
            <Page
              portfolio={portfolio}
              key={`${model.managerCode}-${pageIndex}`}
              className={"model-disclosure"}
            >
              <React.Fragment>
                <Grid container>
                  {pageIndex === 0 ? (
                    <React.Fragment>
                      <Grid item xs={12}>
                        <Typography gutterBottom variant={"h5"}>
                          {portfolio.cprRecommendation.displayName}
                        </Typography>
                      </Grid>
                      <Grid item xs={5} />
                      <Grid item xs={3}>
                        <Typography gutterBottom variant={"h5"}>
                          Type
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography gutterBottom variant={"h5"}>
                          Start
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography gutterBottom variant={"h5"}>
                          End
                        </Typography>
                      </Grid>
                      {tickers.map((ticker, i) => {
                        const startingRecord = constituent[ticker].find(
                          (d) => d["Return"] !== ""
                        );
                        const endingRecord = constituent[ticker]
                          .map((d) => d["Return"] !== "")
                          .lastIndex;
                        return (
                          <React.Fragment key={i}>
                            <Grid item xs={5}>
                              <Typography variant={"h6"}>
                                {i === 0
                                  ? managerName
                                  : manager.managerDetail.ImplementationName}
                                <br />
                                {userIsApproved ? ticker : '(********)'}
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Typography variant={"h6"}>
                                {i === 0
                                  ? managerType
                                  : manager.managerDetail.ImplementationType}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography variant={"h6"}>
                                {startingRecord
                                  ? moment(startingRecord["Date"]).format(
                                      "MM/YYYY"
                                    )
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography variant={"h6"}>
                                {endingRecord
                                  ? moment(
                                      constituent[ticker][endingRecord]["Date"]
                                    ).format("MM/YYYY")
                                  : ""}
                              </Typography>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </React.Fragment>
                  ) : (
                    <Grid item xs={12}>
                      <Typography gutterBottom variant={"h5"}>
                        {portfolio.cprRecommendation.displayName} (Continued)
                      </Typography>
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={3} style={{ marginTop: 0 }}>
                  {Array(COLUMNS_PER_PAGE)
                    .fill("")
                    .map((f, colIndex) => {
                      const recordIndexInColumnStarts =
                        recordIndexOnPageStarts + ROWS_PER_PAGE * colIndex;
                      const recordIndexInColumnEnds =
                        recordIndexOnPageStarts +
                        ROWS_PER_PAGE * (colIndex + 1);
                      // console.log(`Column ${colIndex}: ${recordIndexInColumnStarts} to ${recordIndexInColumnEnds}`);

                      return (
                        <Grid
                          item
                          style={{ width: `${100 / COLUMNS_PER_PAGE}%` }}
                          key={`page-${pageIndex}-col-${colIndex}`}
                        >
                          <Table className={"model-constituent"}>
                            <TableHead>
                              <TableRow>
                                <TableCell>Month</TableCell>
                                {tickers.map((ticker) => {
                                  return (
                                    <TableCell
                                      key={`header-${ticker}`}
                                      align={"center"}
                                    >
                                      {userIsApproved ? ticker : '********'}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {constituent[tickers[0]].map((d, index) => {
                                if (
                                  index >= recordIndexInColumnStarts &&
                                  index < recordIndexInColumnEnds
                                ) {
                                  return (
                                    <TableRow
                                      key={`page-${pageIndex}-col-${colIndex}-row-${index}`}
                                    >
                                      <TableCell size={"small"}>
                                        {moment(d["Date"]).format("MM/YYYY")}
                                      </TableCell>
                                      {tickers.map((ticker) => {
                                        return (
                                          <TableCell
                                            key={`return-${index}-${ticker}`}
                                            align={"center"}
                                            size={"small"}
                                          >
                                            <PercentageNumber
                                              value={
                                                constituent[ticker][index][
                                                  "Return"
                                                ]
                                              }
                                            />
                                          </TableCell>
                                        );
                                      })}
                                    </TableRow>
                                  );
                                } else {
                                  return null;
                                }
                              })}
                            </TableBody>
                          </Table>
                        </Grid>
                      );
                    })}
                </Grid>
              </React.Fragment>
            </Page>
          );
        })}
    </React.Fragment>
  );
};

export default ModelConstDisclosureManager;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/ModelConstDisclosureManager.jsx